import React from 'react';
import { Box } from '@cp/ds/src/components/box';
import { Button } from '@cp/ds/src/components/button';
import { Typography } from '@cp/ds/src/components/typography';
import { MOBILE_BREAKPOINT_THRESHOLD } from '@cp/ds/src/theme';
import { useIsMobile } from '@cp/ds/src/hooks/useIsMobile';
import { ArrowRightIcon } from '@cp/ds/src/icons';
import { styled } from '@cp/ds/src/theme/styled';
import { Roundel } from '@cp/ds/src/components/roundel';
import { SvgIconComponent } from '@cp/ds/src/components/svgIcon';
import { StepFooter } from '../stepFooter';
import stepDone from '../assets/step-done-x3.png';
import stepFail from '../assets/step-fail-x3.png';
import { StepContainer } from '../stepContainer';
import { StepProps } from './model';

const DoneImage = styled(Box)(({ theme }) => ({
  margin: 'auto',
  width: '281px',
  height: '322px',
  background: `url(${stepDone}) center center/100% no-repeat`,
  [theme.breakpoints.up(MOBILE_BREAKPOINT_THRESHOLD)]: {
    width: '400px',
    height: '430px',
  },
}));

const FailImage = styled(Box)(({ theme }) => ({
  margin: 'auto',
  width: '281px',
  height: '322px',
  background: `url(${stepFail}) center center/100% no-repeat`,
  [theme.breakpoints.up(MOBILE_BREAKPOINT_THRESHOLD)]: {
    width: '400px',
    height: '430px',
  },
}));

export interface BlockResultProps extends StepProps {
  errorsCount: number;
  icon: SvgIconComponent;
}

export const BlockResult: React.FC<BlockResultProps> = ({ onSubmit, icon, errorsCount }) => {
  const isMobile = useIsMobile();
  const headerText = errorsCount
    ? 'К сожалению, вы не смогли ответить на все вопросы.'
    : 'Молодец, вы ответили верно на все вопросы! Так держать!';
  const Icon = icon;
  return (
    <>
      <StepContainer sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Roundel size="small" sx={{ display: { xs: 'initial', [MOBILE_BREAKPOINT_THRESHOLD]: 'none' } }}>
          <Icon />
        </Roundel>
        <Typography sx={{ textAlign: 'center', mt: 3, mb: 5 }} variant={isMobile ? 'h2' : 'h1'}>
          {headerText}
        </Typography>
        {errorsCount ? <FailImage /> : <DoneImage />}
        <Typography component="div" sx={{ display: !errorsCount ? 'none' : 'block', textAlign: 'center', mt: 2.5 }}>
          Вы допустили {errorsCount === 1 ? '1 ошибку' : 'несколько ошибок'}. Посмотрите видео снова и попробуйте еще раз.
          <br />
          Мы уверены, что все получится!
        </Typography>
      </StepContainer>
      <StepFooter>
        <Button
          iconRight={isMobile ? undefined : <ArrowRightIcon />}
          onClick={() => onSubmit()}
          sx={{ width: { xs: 1, [MOBILE_BREAKPOINT_THRESHOLD]: 'auto' } }}
        >
          {errorsCount ? 'Попробовать еще раз' : 'К следующему блоку'}
        </Button>
      </StepFooter>
    </>
  );
};
